import React, { useEffect } from 'react';
import { AboutNavigation } from './about/AboutNavigation';
import { AboutHeader } from './about/AboutHeader';
import { AboutStory } from './about/AboutStory';
import { AboutInstructors } from './about/AboutInstructors';
import { AboutValues } from './about/AboutValues';
import { AboutCTA } from './about/AboutCTA';
import { AboutFooter } from './about/AboutFooter';
export function AboutPage() {
  useEffect(() => {
    document.title = "Instructors | Walker's Martial Arts | Bloomington, Illinois";
  }, []);
  return <div className="bg-black min-h-screen" data-id="element-470">
      <AboutNavigation data-id="element-471" />
      <AboutHeader data-id="element-472" />
      <AboutStory data-id="element-473" />
      <AboutInstructors data-id="element-474" />
      <AboutValues data-id="element-475" />
      <AboutCTA data-id="element-476" />
      <AboutFooter data-id="element-477" />
    </div>;
}